import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=5a83d606&lang=pug"
import script from "./partner.vue?vue&type=script&lang=js"
export * from "./partner.vue?vue&type=script&lang=js"
import style0 from "./partner.vue.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports